// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  height: 100%;
}

/* Let #root's height flow to routed pages */
#root > .fctl-app {
  display: contents;
}
`, "",{"version":3,"sources":["webpack://./src/app/app.css"],"names":[],"mappings":"AAAA;;;EAGE,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;AACnB","sourcesContent":["html,\nbody,\n#root {\n  height: 100%;\n}\n\n/* Let #root's height flow to routed pages */\n#root > .fctl-app {\n  display: contents;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
